export const CStoryGalleryFragments = {
  field: `
    fragment storyGallery on storyGallery_MatrixField {
      ... on storyGallery_main_Entry {
        id
        typeHandle
        idName
        heading
      }
      ... on storyGallery_slide_Entry {
        id
        typeHandle
        heading
        copy
        image {
          url @transform(mode: "crop", width: 1000, height: 1000, immediately: true)
          title
          hasFocalPoint
          focalPoint
        },
        mobileImage: image {
          url @transform(mode: "crop", width: 640, height: 640, immediately: true)
          title
          hasFocalPoint
          focalPoint
        }
      }
    }
  `,
};
